import Flex from '@components/Flex/Flex';
import { Dialog, Slide, useTheme } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';
import { Close } from '@mui/icons-material';
import { AlertModalProps } from './AlertModal.types';
import { StyledButton, StyledCloseButton } from './AlertModal.styles';
import Text from '@components/Text/Text';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const AlertModal: React.FC<AlertModalProps> = ({
  onClose,
  open,
  title,
  description,
  buttonProps,
  secondaryButtonProps,
  children,
  hideCloseButton = false,
  dialogProps,
}) => {
  const theme = useTheme();
  return (
    <Dialog
      TransitionComponent={Transition}
      keepMounted
      {...dialogProps}
      open={open}
      onClose={onClose}
      sx={{ backgroundColor: 'rgba(28, 38, 57, 0.5)', ...dialogProps?.sx }}
      PaperProps={{
        ...dialogProps?.PaperProps,
        sx: {
          minWidth: '30%',
          borderRadius: theme.spacing(6),
          ...dialogProps?.PaperProps?.sx,
        },
      }}
    >
      {!hideCloseButton && (
        <StyledCloseButton
          data-testid='alert-close-button'
          onClick={(event) => onClose && onClose(event, 'escapeKeyDown')}
          size='small'
          iconBoxHeight={25}
          iconBoxWidth={25}
          icon={() => <Close sx={{ color: theme.palette.grey.A100 }} />}
        />
      )}
      <Flex
        flex={1}
        flexDirection='column'
        sx={{
          padding: theme.spacing(17, 18),
        }}
      >
        {title && (
          <Text
            variant='h5'
            fontWeight='fontWeightBold'
            textAlign='center'
            mb={9}
          >
            {title}
          </Text>
        )}
        {description && (
          <Text variant='h6' fontWeight='fontWeightMedium' textAlign='center'>
            {description}
          </Text>
        )}
        {children && children}
        <Flex gap={8} justifyContent='center'>
          {buttonProps ? (
            <StyledButton {...buttonProps}>{buttonProps?.title}</StyledButton>
          ) : null}
          {secondaryButtonProps ? (
            <StyledButton color='info' {...secondaryButtonProps}>
              {secondaryButtonProps?.title}
            </StyledButton>
          ) : null}
        </Flex>
      </Flex>
    </Dialog>
  );
};

export default AlertModal;
